export { TimerObserver } from './timerObserver';
export * as timer from './timer';
